export const OFFLINE_ENABLED_KEY = 'offlineEnabled';
